import heroBannerXs from './hero-banner-xs.jpg';
import heroBannerSm from './hero-banner-sm.jpg';
import heroBannerMd from './hero-banner-md.jpg';
import heroBannerLg from './hero-banner-lg.jpg';
import heroBannerXl from './hero-banner-xl.jpg';

export default {heroBannerXs, heroBannerSm, heroBannerMd, heroBannerLg, heroBannerXl}
